import { css } from '@flex-design-system/stitches-react';

const root = css({
  fontSize: 14,
  fontWeight: 400,
  lineHeight: 1.5
})();
const textBase = css({
  color: "$grayDarker"
})();
const textBold = css({
  "&&": {
    fontWeight: 700
  }
})();
const textStrikethrough = css({
  textDecorationLine: "line-through",
  color: "$grayDark"
})();
const textCode = css({
  "&&": {
    color: "$magenta"
  },
  fontSize: 13,
  lineHeight: 1.5,
  background: "$blackAlpha004",
  boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.06)",
  borderRadius: 4,
  padding: "2px 4px"
})();
const textLink = css({
  display: "inline",
  "span, strong, em": {
    color: "$cosmicBlue"
  },
  "&:hover": {
    "span, strong, em": {
      color: "$cosmicBlueDark"
    },
    textDecoration: "underline",
    textDecorationColor: "$cosmicBlueLighter",
    textUnderlineOffset: 2
  }
})();
const textItalic = css({
  fontStyle: "italic"
})();
const textUnderline = css({
  textDecoration: "underline"
})();
const paragraph = css({})();
const heading1 = css({
  fontSize: 24,
  fontWeight: 600,
  lineHeight: "33px",
  color: "$grayDarker"
})();
const heading2 = css({
  fontSize: 20,
  fontWeight: 600,
  lineHeight: "28px",
  color: "$grayDarker"
})();
const heading3 = css({
  fontSize: 16,
  fontWeight: 600,
  lineHeight: "22px",
  color: "$grayDarker"
})();
const _listBase = { padding: "0", margin: "0", marginLeft: "20px" };
const listItem = css({
  lineHeight: 1.5,
  marginLeft: -4,
  "&::marker": {
    color: "$grayDark"
  }
})();
const ol = css({
  ..._listBase
})();
const ul = css({
  ..._listBase
})();
const olDepth1 = css({ listStyleType: "decimal" })();
const olDepth2 = css({ listStyleType: "lower-alpha" })();
const olDepth3 = css({ listStyleType: "lower-roman" })();
const olDepth4 = css({ listStyleType: "lower-greek" })();
const olDepth5 = css({ listStyleType: "lower-latin" })();
const ulDepth1 = css({ listStyleType: "disc" })();
const ulDepth2 = css({ listStyleType: "circle" })();
const ulDepth3 = css({ listStyleType: "square" })();
const ulDepth4 = css({ listStyleType: "circle" })();
const ulDepth5 = css({ listStyleType: "square" })();
const nestedList = css({})();
const nestedListItem = css({
  listStyleType: "none"
})();
const WIDTH = 3;
const blockquote = css({
  position: "relative",
  lineHeight: 1.5,
  margin: 0,
  padding: 0,
  paddingLeft: 13,
  "&:before": {
    content: "",
    position: "absolute",
    left: 0,
    top: -3,
    width: WIDTH,
    height: `calc(100% + ${WIDTH * 2}px)`,
    background: "$grayLighter",
    borderRadius: WIDTH
  }
})();
const tableStyle = css({
  borderCollapse: "collapse",
  borderSpacing: 0,
  overflowY: "scroll",
  overflowX: "scroll",
  tableLayout: "fixed",
  width: "fit-content",
  marginTop: "var(--flexical-table-margin-top, 16px)",
  marginRight: "var(--flexical-table-margin-right, 24px)",
  marginBottom: "var(--flexical-table-margin-bottom, 20px)",
  "&:focus-visible": {
    outline: "2px solid $cosmicBlue"
  }
})();
const tableCell = css({
  border: "1px solid $black016",
  width: "120px",
  verticalAlign: "top",
  textAlign: "start",
  padding: "6px 8px",
  position: "relative",
  outline: "none",
  overflow: "auto",
  borderRadius: 2
})();
const tableScrollableWrapper = css({
  overflowX: "auto",
  margin: "16px 24px 20px 0px",
  padding: "1px",
  // outline이 보일 영역 확보
  ["--flexical-table-margin-top"]: "0px",
  ["--flexical-table-margin-bottom"]: "0px",
  ["--flexical-table-margin-right"]: "0px"
})();
const tableSelected = css({
  outline: "2px solid rgb(60, 132, 244)"
})();
const tableCellSelected = css({
  caretColor: "transparent"
})();
const tableCellHeader = css({
  backgroundColor: "$grayLightest",
  textAlign: "start"
})();

export { _listBase, blockquote, heading1, heading2, heading3, listItem, nestedList, nestedListItem, ol, olDepth1, olDepth2, olDepth3, olDepth4, olDepth5, paragraph, root, tableCell, tableCellHeader, tableCellSelected, tableScrollableWrapper, tableSelected, tableStyle, textBase, textBold, textCode, textItalic, textLink, textStrikethrough, textUnderline, ul, ulDepth1, ulDepth2, ulDepth3, ulDepth4, ulDepth5 };
//# sourceMappingURL=base.mjs.map
